<template>
  <div class="adml-root">

    <!-- ── Overlay mobile ──────────────────────────── -->
    <div v-if="sidebarOpen && isMobile" class="adml-overlay" @click="sidebarOpen = false"></div>

    <!-- ══════════════════════════════════════════════
         SIDEBAR
    ══════════════════════════════════════════════ -->
    <aside class="adml-sidebar" :class="{ 'adml-sidebar--open': sidebarOpen, 'adml-sidebar--closed': !sidebarOpen }">

      <!-- Logo / Brand -->
      <div class="adml-brand bg-white">
        <div v-if="sidebarOpen" class="adml-brand__logo">
          <img src="/logo.png" class=" " alt="Stag Fondation" loading="lazy" />
        </div>
        <button class="adml-toggle-btn" @click="sidebarOpen = !sidebarOpen" :title="sidebarOpen ? 'Réduire' : 'Élargir'">
          <svg v-if="sidebarOpen" class="adml-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
          <svg v-else class="adml-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      <!-- Nav items -->
      <nav class="adml-nav">
        <router-link
          v-for="item in menuItems"
          :key="item.path"
          :to="item.path"
          class="adml-nav-item"
          active-class="adml-nav-item--active"
          :title="!sidebarOpen ? item.label : ''"
        >
          <!-- icons via inline SVG by icon key -->
          <svg class="adml-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path v-if="item.icon==='dashboard'" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
            <path v-else-if="item.icon==='folder'" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"/>
            <path v-else-if="item.icon==='graduation'" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M12 14l9-5-9-5-9 5 9 5zm0 0v5m-5-2.5v3l5 2.5 5-2.5v-3"/>
            <path v-else-if="item.icon==='users'" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0"/>
            <path v-else-if="item.icon==='building'" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
            <path v-else-if="item.icon==='file'" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            <path v-else-if="item.icon==='heart'" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
          <path v-else-if="item.icon==='calendar'" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
         <path 
  v-else-if="item.icon==='star'" 
  stroke-linecap="round" 
  stroke-linejoin="round" 
  stroke-width="1.8" 
  d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l2.036 6.26a1 1 0 00.95.69h6.588c.969 0 1.371 1.24.588 1.81l-5.329 3.87a1 1 0 00-.364 1.118l2.036 6.26c.3.921-.755 1.688-1.54 1.118l-5.329-3.87a1 1 0 00-1.176 0l-5.329 3.87c-.784.57-1.838-.197-1.539-1.118l2.036-6.26a1 1 0 00-.364-1.118L.875 11.687c-.783-.57-.38-1.81.588-1.81h6.588a1 1 0 00.95-.69l2.048-6.26z"
/>
            <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
          </svg>
          <span class="adml-nav-item__label" v-if="sidebarOpen">{{ item.label }}</span>
        </router-link>
      </nav>

      <!-- Bottom: back to site + logout -->
      <div class="adml-sidebar-foot">
        <a href="/" class="adml-nav-item" @click.prevent="goToSite" :title="!sidebarOpen ? 'Retour au site' : ''">
          <svg class="adml-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
          </svg>
          <span class="adml-nav-item__label" v-if="sidebarOpen">Retour au site</span>
        </a>
      </div>
    </aside>

    <!-- ══════════════════════════════════════════════
         MAIN
    ══════════════════════════════════════════════ -->
    <div class="adml-main" :class="{ 'adml-main--wide': !sidebarOpen }">

      <!-- Header -->
      <header class="adml-header">
        <!-- Mobile burger -->
        <button class="adml-mobile-burger" @click="sidebarOpen = !sidebarOpen">
          <svg class="adml-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
          </svg>
        </button>

        <p class="adml-header__brand">Stag Fondation <span>— Administration</span></p>

        <div class="adml-header__right">
          <!-- Notifications -->
          <!-- <button class="adml-notif-btn">
            <svg class="adml-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
            </svg>
            <span class="adml-notif-dot" v-if="notifCount > 0">{{ notifCount }}</span>
          </button> -->

          <!-- User avatar + name -->
          <div class="adml-user" @click="togglelogout">
            <div class="adml-user__avatar"><LogOut class="adml-icon"></LogOut></div>
            <span class="adml-user__name" v-if="user">Deconnexion</span>
           
          </div>
        </div>
      </header>

      <!-- Router view -->
      <router-view name="tree"></router-view>

      <!-- Global toast -->
      <Transition name="adm-toast">
        <div v-if="toastMessage" class="adml-toast">{{ toastMessage }}</div>
      </Transition>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LogOut } from 'lucide-vue-next';
export default {
  name: 'AdminLayout',
  components: { LogOut },
  data() {
    return {
      sidebarOpen: true,
      isMobile: false,
      notifCount: 3,
      menuItems: [
        { icon: 'dashboard',  label: 'Tableau de bord', path: 'dashboard' },
        { icon: 'folder',     label: 'Projets',         path: 'projets' },
        { icon: 'graduation', label: 'Formations',      path: 'formations' },
        { icon: 'users',      label: 'Contacts',        path: 'contacts' },
        { icon: 'users',      label: 'Équipe',          path: 'teams' },
        { icon: 'building',   label: 'Associations',    path: 'associations' },
        { icon: 'file',       label: 'Articles',        path: 'articles' },
        { icon: 'calendar', label: 'Événements', path: 'evenements' },
        { icon: 'heart',      label: 'Dons',            path: 'dons' },
        { icon: 'star', label: 'Témoignages', path: 'avis' }
        // { icon: 'settings',   label: 'Paramètres',      path: 'configurations' },
      ],
    }
  },
  computed: {
    ...mapState({ toastMessage: s => s.toastMessage, user: s => s.user }),
    userInitial() {
      return this.user?.name ? this.user.name[0].toUpperCase() : 'A'
    }
  },
  watch: {
    toastMessage(val) {
      if (val) setTimeout(() => this.$store.commit('CLEAR_TOAST'), 3000)
    }
  },
  methods: {
    goToSite() { window.location.href = '/' },
    toggleUserMenu() {},
    checkMobile() {
      this.isMobile = window.innerWidth < 768
      if (this.isMobile) this.sidebarOpen = false
    },
    togglelogout() {
      // Clear user data and redirect to login
      this.$store.commit('SET_USER', null)
      localStorage.removeItem('token')
      this.$router.push('/systeme/admin/login')
    }
    
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    document.addEventListener('click', (e) => {
      if (this.isMobile && this.sidebarOpen && !e.target.closest('.adml-sidebar') && !e.target.closest('.adml-mobile-burger')) {
        this.sidebarOpen = false
      }
    })
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile)
  }
}
</script>

<style scoped>
/* ── Tokens ─────────────────────────────────────── */
.adml-root {
  --forest:   #1B3A2D; --forest-l: #244D3C;
  --terra:    #C85A2A; --amber: #E8933A; --sage: #7A9E87;
  --cream:    #F5EFE0; --cream-d:#EDE4CC;
  --ink:      #1A1A18; --ink-60:rgba(26,26,24,.6);
  --ink-12:   rgba(26,26,24,.12); --white:#FFFFFF;
  --sidebar-w:240px; --sidebar-c:64px;
  --fd:'Cormorant Garamond',Georgia,serif;
  --fb:'DM Sans',sans-serif;
  font-family:var(--fb);
  display:flex; min-height:100vh; background:var(--cream);
}

/* ── Sidebar ─────────────────────────────────────── */
.adml-sidebar {
  position:fixed; left:0; top:0; height:100vh; z-index:100;
  background:var(--forest);
  display:flex; flex-direction:column;
  transition:width .25s cubic-bezier(.4,0,.2,1);
  overflow:hidden;
}
.adml-sidebar--open   { width:var(--sidebar-w); }
.adml-sidebar--closed { width:var(--sidebar-c); }

/* Brand row */
.adml-brand { display:flex; align-items:center; justify-content:space-between; padding:.85rem .75rem; height:60px; border-bottom:1px solid rgba(255,255,255,.08); flex-shrink:0; }
.adml-brand__logo img { height:36px; object-fit:cover; filter:brightness(1); }

/* Toggle button */
.adml-toggle-btn {  background:var(--forest); border:none; border-radius:6px; width:34px; height:34px; display:flex; align-items:center; justify-content:center; cursor:pointer; color:rgba(255,255,255,.8); flex-shrink:0; transition:background .2s ease; }
.adml-toggle-btn:hover {  background:var(--forest); }

/* Nav */
.adml-nav { flex:1; padding:.75rem .5rem; overflow-y:auto; overflow-x:hidden; }
.adml-nav-item {
  display:flex; align-items:center; gap:.75rem;
  padding:.7rem .75rem; border-radius:6px; margin-bottom:.2rem;
  color:rgba(255,255,255,.7); text-decoration:none;
  transition:background .18s ease, color .18s ease;
  white-space:nowrap; overflow:hidden;
}
.adml-nav-item:hover { background:rgba(255,255,255,.1); color:var(--white); }
.adml-nav-item--active { background:rgba(255,255,255,.16); color:var(--amber); }
.adml-nav-item__label { font-size:.875rem; font-weight:500; }

/* Sidebar foot */
.adml-sidebar-foot { padding:.5rem; border-top:1px solid rgba(255,255,255,.08); flex-shrink:0; }

/* Icon */
.adml-icon { width:20px; height:20px; flex-shrink:0; }

/* ── Overlay ─────────────────────────────────────── */
.adml-overlay { position:fixed; inset:0; background:rgba(0,0,0,.4); z-index:99; }

/* ── Main content ────────────────────────────────── */
.adml-main {
  margin-left:var(--sidebar-w);
  transition:margin-left .25s cubic-bezier(.4,0,.2,1);
  /* Toujours aussi haut que l'écran */
  width: 100%;
  min-height:100vh;
  height:100vh;
  display:flex;
  flex-direction:column;
  overflow:hidden; /* empêche scroll parasite */
}
.adml-main--wide { margin-left:var(--sidebar-c); }

/* La zone router-view occupe tout l'espace sous le header */
.adml-main :deep(.adm-page),
.adml-main > *:not(.adml-header):not(.adml-toast) {
  flex:1;
  overflow-y:auto;
}

/* ── Header ──────────────────────────────────────── */
.adml-header {
  position:sticky; top:0; z-index:50; height:60px;
  background:var(--white); border-bottom:1px solid var(--ink-12);
  display:flex; align-items:center; justify-content:space-between;
  padding:0 1.5rem; gap:1rem; flex-shrink:0;
}
.adml-header__brand { font-family:var(--fd); font-size:1.05rem; font-weight:600; color:var(--ink); white-space:nowrap; }
.adml-header__brand span { color:var(--ink-60); font-weight:400; font-size:.9rem; }
.adml-header__right { display:flex; align-items:center; gap:.75rem; }

/* Notif button */
.adml-notif-btn { position:relative; background:none; border:none; cursor:pointer; color:var(--ink-60); padding:.35rem; display:flex; align-items:center; transition:color .2s ease; }
.adml-notif-btn:hover { color:var(--terra); }
.adml-notif-dot { position:absolute; top:-2px; right:-2px; background:var(--terra); color:var(--white); font-size:.65rem; font-weight:700; min-width:16px; height:16px; border-radius:999px; display:flex; align-items:center; justify-content:center; padding:0 3px; }

/* User */
.adml-user { display:flex; align-items:center; gap:.5rem; cursor:pointer; padding:.35rem .5rem; border-radius:6px; transition:background .2s ease; }
.adml-user:hover { background:var(--cream); }
.adml-user__avatar { width:32px; height:32px; border-radius:50%; background:var(--forest); color:var(--white); font-weight:600; font-size:.82rem; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
.adml-user__name { font-size:.84rem; font-weight:500; color:var(--ink); }

/* Mobile burger (hidden on desktop) */
.adml-mobile-burger { display:none; background:none; border:none; cursor:pointer; color:var(--ink); padding:.35rem; }

/* Toast */
.adml-toast { position:fixed; bottom:1.5rem; right:1.5rem; z-index:300; background:var(--forest); color:var(--cream); padding:.85rem 1.4rem; border-radius:6px; font-size:.87rem; box-shadow:0 8px 24px rgba(0,0,0,.25); }
.adm-toast-enter-active, .adm-toast-leave-active { transition:opacity .3s ease, transform .3s ease; }
.adm-toast-enter-from, .adm-toast-leave-to { opacity:0; transform:translateY(8px); }

/* ── Responsive ──────────────────────────────────── */
@media (max-width:768px) {
  .adml-sidebar { width:var(--sidebar-w) !important; left:-100%; }
  .adml-sidebar--open { left:0; }
  .adml-main, .adml-main--wide { margin-left:0; }
  .adml-mobile-burger { display:flex; }
  .adml-header__brand span { display:none; }
  .adml-user__name { display:none; }
}
</style>